export const fmtDateLong = (
  d: Date,
  locales: Intl.LocalesArgument = 'en-US'
) => {
  return d.toLocaleDateString(locales, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
};

const isWeekend = (d: Date) => {
  const day = d.getDay();
  return day === 0 || day === 6;
};
/* Move `n` working days from `date`, skipping Saturdays and Sundays.
   n = 0 returns the same date (rolled forward to a weekday if it lands on a weekend). */
const addBusinessDays = (date: Date, n: number) => {
  const d = new Date(date);
  while (isWeekend(d)) d.setDate(d.getDate() + 1);
  let remaining = Math.max(0, n || 0);
  while (remaining > 0) {
    d.setDate(d.getDate() + 1);
    if (!isWeekend(d)) remaining--;
  }
  return d;
};

export const resolveSchedule = (
  startDay: number,
  duration: number,
  projectStart: Date
) => {
  const start = addBusinessDays(projectStart, startDay || 0);
  const end = addBusinessDays(start, Math.max(0, (duration || 1) - 1));
  return { start, end };
};
